export default "__VITE_ASSET__qJxjw4Oa__"